import { usePreviousUrlStore } from 'links/login/stores/usePreviousUrlStore'

export const usePreviousUrl = () =>
	usePreviousUrlStore((state) => state.previousUrl)
